
<div class="mr-3">
    <a @click="onMenu">
        <div class="nav-dropdown" >
            <v-icon color="primary" class="nav-icon mr-2">mdi-bell-outline</v-icon>
            <v-badge
                :content="total"
                :color="totalColor"
                :tile="true"
            />
            <i class="nav-icon fas fa-caret-down" style="margin-left: 20px; font-size: 22px!important;"></i>
        </div>
    </a>
</div>
